import en from './en.json'
import ru from './ru.json'

export const languages = {
	en,
	ru,
}


